import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const CreateSettingsSlc = createSlice({
  name: "createsettings",
  initialState,
  reducers: {
    requestStart(state) {
      state.loading = true;
      state.error = null;
    },
    requestSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    requestFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { requestStart, requestSuccess, requestFailure } =
  CreateSettingsSlc.actions;

export default CreateSettingsSlc.reducer;

export const Createsettings = (formValues) => async (dispatch) => {
  try {
    dispatch(requestStart());

    await axios
      .post("/private/settings", formValues)
      .then((respo) => {
        // toast.success("Please Check your inbox.");
        dispatch(requestSuccess(respo?.data[0]));
        // navigate.push("/dashboard");
      })
      .catch((err) => {
        toast.error(err);
        dispatch(requestFailure(err));
      });
  } catch (error) {
    dispatch(requestFailure(error?.response?.data || "Something went wrong!"));
    toast.error(error?.response?.data || "Something went wrong!");
  }
};
